module.exports = function(permission) {
    var hasSuperAdminRole = this.$store.getters['Auth/hasSuperAdminRole'];
    var hasPermissionTo = this.$store.getters['Auth/hasPermissionTo'];

    if (hasSuperAdminRole) return true;

    return hasPermissionTo(permission);
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/methods/has-permission.js